<template>
  <div id="manage">
    <div class="content">
        <div class="titleBiao"><span style="color:#c30d23;cursor:pointer;" @click="goback(2)">展演管理</span> /  节目列表</div>
        <div class="botBox" style="padding-top:20px;">
            <div class="bottomBox">
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="stuColumns" :data="stuList" :loading="loading"></Table>
                </div>
                <Page :page-size="pageSize" :total="total" show-total :current="pageNum" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                performance_id:'',
                total:null,
                pageNum:1,
                pageSize:10,
                loading:false,
                stop_reason:'',
                stuColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },
                    
                    {
                        title: '节目名称',
                        align: 'center',
                        key: 'program_name',
                    },
                    
                    {
                        title: '节目人数',
                        align: 'center',
                        key: 'people_num',
                        width:80,
                        render: (h, params) => {
                            return h('div', params.row.people_num+"人");
                        }
                    },                    
                    {
                        title: '节目类别',
                        align: 'center',
                        key: 'performance_group_name',
                        width:80
                    },
                    {
                        title: '参演组别',
                        align: 'center',
                        key: 'performance_category_name',
                        width:80
                    },
                    {
                        title: '人员名单',
                        align: 'center',
                        key: 'student_names',
                        width:90
                    },
                    {
                        title: '单位名称',
                        align: 'center',
                        key: 'mechanism',
                        render: (h, params) => {
                                return h('div',{
                                    style:{
                                        overflow:'hidden',
                                        padding:'10px 0'
                                    }
                                },[
                                    h('div',{
                                        style:{
                                            width:'130px',
                                            float:'left',
                                            margin:'0px 0 0 11px',
                                        },
                                    },[
                                        h('div',{
                                            style:{
                                                width:'130px',
                                                overflow:'hidden',
                                            },
                                        },[
                                            h('div',{
                                                style:{
                                                    float:'left',
                                                }
                                            },params.row.mechanism),
                                        ]),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.master),
                                        h('div',{
                                            style:{
                                                textAlign:'left'
                                            }
                                        },params.row.phone),
                                    ])
                                ]);
                        }
                    },
                    {
                        title: '提交时间',
                        align: 'center',
                        key: 'updated_at',
                        width:100,
                    },
                    
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.stop_reason='';
                                                this.$Modal.confirm({
                                                    render: (h) => {
                                                        return h('Input', {
                                                            props: {
                                                                value: this.stop_reason,
                                                                autofocus: true,
                                                                placeholder: '请输入移除的原因'
                                                            },
                                                            style:{
                                                                border:'1px solid #dcdcdc'
                                                            },
                                                            on: {
                                                                input: (val) => {
                                                                    this.stop_reason = val;
                                                                }
                                                            }
                                                        })
                                                    },
                                                    onOk: () => {
                                                        _this.$axios.post('removeperformanceuser',{
                                                            performance_user_id:params.row.id,
                                                            del_reason:_this.stop_reason
                                                        }).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('删除成功');
                                                                _this.getPerformanceUserList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        this.stop_reason='';
                                                        this.getPerformanceUserList(0)
                                                    }
                                                })
                                            }
                                        }
                                    }, '移除'),
                                ]);
                            // }
                        }
                    },
                    // {
                    //     title: '导出',
                    //     align: 'center',
                    //     key: 'bespeak_count',
                    //     render: (h, params) => {
                    //         // if(params.row.status==0){
                    //             return h('div', [
                    //                 h('button', {
                    //                     props: {
                    //                         type: 'primary',
                    //                         size: 'small',
                    //                     },
                    //                     style: {
                    //                         backgroundColor:'rgba(0,0,0,0)',
                    //                         border:'none',
                    //                     },
                    //                     on: {
                    //                         click: () => {
                    //                             let _this=this;
                    //                             this.$Modal.confirm({
                    //                                 title: '提示',
                    //                                 content: '<p>确定要导出报名汇总表?</p>',
                    //                                 okText: '确定',
                    //                                 cancelText: '取消',
                    //                                 onOk: () => {
                    //                                     _this.$axios.post('getuploadperformanceuserurl',{program_id:params.row.id}).then(res=>{
                    //                                         if(res.data.code==200){
                    //                                             window.open(res.data.data);
                    //                                          }
                    //                                          else{
                    //                                              this.$Message.error(res.data.message);
                    //                                          }
                    //                                     }).catch(function (error) {
                    //                                       console.log(error);
                    //                                     });
                    //                                 },
                    //                                 onCancel: () => {
                    //                                     // this.$Message.info('取消');
                    //                                 }
                    //                             });
                    //                         }
                    //                     }
                    //                 }, '报名汇总表'),
                    //             ]);
                    //         // }
                    //     }
                    // },
                ],
                stuList: [],
            }
        },
        methods:{
            goback(index){
                this.$router.go(-1);
            },
            getPerformanceUserList(index){
                let _this=this;
                if(index==1){
                    _this.pageNum=1;
                }
                _this.$axios.post('getperformanceuserlist',{
                    performance_id:_this.performance_id,
                    page:_this.pageNum
                }).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.stuList = res.data.data.list;
                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.pageNum = num;
                this.getPerformanceUserList(0);
            },
        },
        created(){
            let _this=this; 
            _this.performance_id=this.$route.query.performance_id;
            _this.getPerformanceUserList(0);
        }
    }
</script>

<style scoped>
/**/
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .titleBiao{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
/**/
    .urlLogo{
        width: 150px;
        height: 210px;
        /*background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;*/
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 58px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 58px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #e6e6e6;
        padding: 0 20px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/performance/programlist.vue